// The API supplies the UTC instant after the last valid day in Europe/Madrid.
// Never interpret a Look calendar date using the customer's local timezone.
export const isFeatureExpired = (feature, now = Date.now()) => !!feature?.expired
    || (!!feature?.expires_at && Date.parse(feature.expires_at) <= now);

export const describeExpiredFeature = (category, feature) => ({
    category_id: category.id, feature_id: feature.id, name: feature.name,
    room_name: category.roomName, selection_deadline: feature.selection_deadline,
});

export const expiredSelections = (categories, now = Date.now()) => categories.flatMap(category => {
    const feature = category.features.find(item => item.id === category.selected_feature);
    return feature && isFeatureExpired(feature, now) ? [describeExpiredFeature(category, feature)] : [];
});

export const applySelectionDeadlines = (categories, now = Date.now()) => {
    const removed = expiredSelections(categories, now);
    categories.forEach(category => {
        category.features.forEach(feature => { feature.expired = isFeatureExpired(feature, now); });
        if (category.features.some(feature => feature.id === category.selected_feature && feature.expired)) {
            category.expired_selected_feature = category.selected_feature;
            category.selected_feature = 0;
        } else if (category.selected_feature) {
            category.expired_selected_feature = null;
        }
    });
    return removed;
};

export const formatDeadline = (date) => date ? date.split('-').reverse().join('/') : '';

// Only options offered to this unit determine whether the whole category has expired.
export const isCategoryExpired = (category, now = Date.now()) => {
    const offeredFeatures = (category.features || []).filter(feature => !feature.disabled);
    return offeredFeatures.length > 0 && offeredFeatures.every(feature => isFeatureExpired(feature, now));
};

export const isPromotionExpired = (settings, now = Date.now()) =>
    !!settings?.promotion_expires_at && Date.parse(settings.promotion_expires_at) <= now;

export const isFeatureVisuallySelected = (category, feature) => category.selected_feature === feature.id
    || (!category.selected_feature && feature.expired && category.expired_selected_feature === feature.id);
